import React, { useEffect, useState } from 'react';
import { Button, Card, Spin, Typography } from 'antd';
import { find } from '../../../services/universal.service';
import { dateFormate } from '../../../utils/DateUtility';
import { connect } from 'react-redux';
import { setFilters } from '../../../state/actions/searchFilters';
import { useNavigate } from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import {  CalendarOutlined } from "@ant-design/icons";

const cardBodyStyle: React.CSSProperties = { paddingTop: '10px' };

const PreviouseSearchCardPage: React.FC<any> = ({setFilters, user}) => {
    const navigate = useNavigate();
    const [searchData, SetSearchData] = useState([])
    const [loader, SetLoader] = useState(true);
    const [pageNo, setPageNo] = useState(0);
    const [loadMore, setLoadMore] = useState(true);

    const onClick = () => {
        SetLoader(true);
        const newPage = pageNo + 1;
        setPageNo(newPage);
        jobsHistory(newPage);
    }
    useEffect( () => {
        jobsHistory(0);
    }, []);

    const jobsHistory = async (skip: number) => {
        const filter: any = { skip: skip, limit: 5 };
        if(user && user._id) {
            filter['filter'] = {search_by_id: user._id};
        }
        let history: any = await find('previousSearch/list', filter);        
        if (history && history.data && history.data.length < 5) {
            setLoadMore(false);
        }
        history = [...searchData, ...history.data];
        SetSearchData(history);
        SetLoader(false);
    }

    const OnCardClick = (filters: any) => {
        console.log('filters>>', filters.execution_pattern);
        setFilters(filters.execution_pattern);
        navigate('/job-search', { replace: true });
    }

    return (
        <Card hoverable className="scrollbox lr-card mb-5 mt-5 prevSearchCard" bodyStyle={cardBodyStyle}>
            <Typography.Title className="mt-0 pl-4 pt-4 pb-4 bg-gray-1 heading-Sidebar" level={4}>Previous Searches</Typography.Title>
            {searchData.map((search: any, index) => {
                return <div key={index} className="pointer prevSearch" title='View Job' onClick={() => OnCardClick(search)}>
                    <Typography.Text className='recSearchJob'>{search?.execution_pattern?.Keyword}  {search?.execution_pattern?.jobFunction} </Typography.Text>
                   {search?.execution_pattern?.Location && <Typography.Text className='recSearchJob'> with {search?.execution_pattern?.Location.join('  ')}</Typography.Text>} <br/>
                   {search?.execution_pattern?.Experience && <><Typography.Text className='recSearchJob'> with {search?.execution_pattern?.Experience.join(' - ')} Yrs EXP.</Typography.Text> <br /></>}
                   {search?.execution_pattern?.Jobfreshness &&  <><Typography.Text style={{fontSize: '1.1em', color: '#3b3b3b' }}>Job Freshness {search?.execution_pattern?.Jobfreshness}</Typography.Text> <br /></>} 
                   {search?.execution_pattern?.Qualifications &&  <><Typography.Text style={{fontSize: '1.1em', color: '#3b3b3b' }}>Qualifications {search?.execution_pattern?.Qualifications}</Typography.Text> <br /></>}
                   {search?.execution_pattern?.Remote &&  <><Typography.Text style={{fontSize: '1.1em', color: '#3b3b3b' }}>{search?.execution_pattern?.Remote}</Typography.Text> <br /></>} 
                    <Typography.Text style={{fontSize: '1.1em', color: '#3b3b3b' }}>{search?.execution_pattern?.JobsortOn}  {search?.execution_pattern?.Jobtype && (search?.execution_pattern?.Jobtype)} </Typography.Text>
                    <Typography.Text className="lr-card-date mt-1"><CalendarOutlined /> {dateFormate(search?.execution_at, 'DD MMM YYYY, h:mm a')}</Typography.Text>
                </div>
            })}   
            {loader && <div className="TextCenter pt-2"> <Spin tip="Loading" key={0} size="small" /> </div>}
            {loadMore && <div className='TextCenter mt-5 mb-5'><Button size="small" onClick={onClick} className='pr-3 pl-3'>View More</Button> </div>}
            {!searchData.length && <Title level={5} className="mt-0 mb-0 pl-5">Search not found!</Title>}
        </Card>
    )
};

const mapStateToProps = (state: any) => {
    return { user: state.reducer.auth.user};
};

function mapDispatchToProps(dispatch: any) {
    return {
        setFilters: (payload: any) => dispatch(setFilters(payload))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviouseSearchCardPage);
